const PERSIST_AUTH_KEY = 'persist:v100-xbox-auth'

export const getPersistedAccessToken = (): string | null => {
  try {
    const persistedAuthRaw = localStorage.getItem(PERSIST_AUTH_KEY)
    if (!persistedAuthRaw) {
      return null
    }

    const persistedAuth = JSON.parse(persistedAuthRaw)
    const accessTokenRaw = persistedAuth?.accessToken
    if (!accessTokenRaw) {
      return null
    }

    const accessToken = JSON.parse(accessTokenRaw)
    return typeof accessToken === 'string' && accessToken ? accessToken : null
  } catch (error) {
    return null
  }
}

export const getStoredAccessToken = (): string | null => {
  return (
    localStorage.getItem('rememberToken') ||
    sessionStorage.getItem('sessionToken') ||
    getPersistedAccessToken()
  )
}
